import styled from "styled-components"

export const StyledHeader = styled.header`
  background-color: white;
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 2px grey;
  position: relative;
`;

export const StyledLogoContainer = styled.div`
  padding-left: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledImage = styled.img`
  height: 100%;
`;

export const StyledSignOutContainer = styled.div`
  padding-right: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;